import { render, staticRenderFns } from "./addDataForm.vue?vue&type=template&id=e8735dd6&scoped=true&"
import script from "./addDataForm.vue?vue&type=script&lang=js&"
export * from "./addDataForm.vue?vue&type=script&lang=js&"
import style0 from "./addDataForm.vue?vue&type=style&index=0&id=e8735dd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8735dd6",
  null
  
)

export default component.exports